module.exports = __webpack_public_path__ + "static/img/banner55.fefa390.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner55.jpg
// module id = tDx6
// module chunks = 6